
export class ProductPrice {
    public ratecard_product_id: number
    public price_wvat: number
    
    constructor(id?: number, price_wvat?: string) {
        this.ratecard_product_id = id
        this.price_wvat = parseFloat(price_wvat)
    }
}